import { Component, OnInit } from "@angular/core";
import { DataService } from '../../shared/dataService';
import { BlogEntry } from '../../shared/blogEntry';

//import { pipe } from 'rxjs';

@Component({
    selector: "blogEntry-list",
    templateUrl: "blogList.component.html",
    styleUrls: []
})
export class BlogListComponent implements OnInit {

    constructor(private data: DataService) {
        
    }

    public blogEntries : BlogEntry[] = [];

    ngOnInit(): void {
        this.data.loadBlogEntries().
            subscribe(p => {
                if (p) {
                    this.blogEntries = this.data.blogEntries;
                }
            });
    }
}